export default __webpack_public_path__ + "static/media/eye-svg.ba1404b0.svg";